<template>
  <div class="news-content-container">
    <back-open-chenter />
    <div class="news-content-panel">
      <div class="news-title">全球第二！腾讯视觉AI再突破</div>
      <div class="news-date">2022年6月6日</div>
      <div class="news-content">
        <div class="image-panel">
          <img class="news-image" src="../img/detail/Information/news17/news17_17.gif"/>
        </div>
        <p>近日，国际权威研究机构Gartner发布2022年度《Magic Quadrant for Cloud AI Developer Services》研究报告：</p>
        <p></p>
        <h3>腾讯位列“挑战者“象限</h3>
        <p></p>
        <p>至此，腾讯连续三年入选Gartner云AI开发者服务魔力象限，为中国云厂商中唯一。</p>
        <p>同时，腾讯在计算机视觉方面获得了全球第二的评分排名，再次印证了腾讯云在云AI开发者服务领域的国际领先地位。</p>
        <div class="news-content-box">
          <div class="news-content-box-top">
            Gartner指出
            <span>●</span>
            <span>●</span>
          </div>
          <div class="news-content-box-bottom">
            <div class="left"></div>
            <div class="right">
              <div class="right-description">
                <p></p>
                <p>○ 作为该领域领先的“挑战者”，腾讯将其丰富的人工智能资源用于游戏、视觉和其他服务，不断创新与完善服务能力；</p>
                <p></p>
                <p>○ 同时开发了CAIDS（云AI开发者服务）市场上最广泛的合作伙伴生态系统之一，为开发者和合作伙伴提供了专业且良好的生态环境；</p>
                <p>...</p>
              </div>
            </div>
          </div>
        </div>
        <p>腾讯AI拿高分的秘笈👇</p>
        <div class="news-content-text-nlp">
          <div>
            <p>1、在自然语言、计算机视觉、自动机器学习三大领域表现突出。尤其在计算机视觉方面，联合腾讯优图实验室等领先团队，融合互联网媒体AI应用经验，打造了扎实的技术基础，并提供了非常丰富的计算机视觉产品组合。</p>
          </div>
          <div>
            <p>2、提供了丰富的标准化AI应用服务，构筑了完善的人工智能产品矩阵，涵盖智能语音、自然语言处理等多样化定制化产品。比如在自然语言处理方面，腾讯云提供了情感分析、智能分词、文本纠错等数十种能力，开箱即用，大大满足了开发者各种AI应用需求。</p>
          </div>
        </div>
        <p>未来，我们将结合游戏、社交、移动支付等场景，不断做强技术支撑和开发服务，持续服务全球AI开发者群体。</p>
        <div class="news-content-box">
          <div class="news-content-box-top">
            数说腾讯AI
            <span>●</span>
            <span>●</span>
          </div>
          <div class="news-content-box-bottom">
            <div class="left"></div>
            <div class="right">
              <div class="right-description">
                <p></p>
                <div>优图实验室</div>
                <p>在算法研究方面，优图的研究成果多次在人工智能国际权威比赛中创造了世界纪录，拥有1600余项AI相关专利，发表顶会论文超过300余篇。在学术研究方面，优图公开发表的论文涵盖ICCV，CVPR，AAAI等各类顶级会议，仅2022年即被国际CV顶级会议CVPR接受了30篇论文。</p>
                <div>腾讯云AI</div>
                <p>已提供了300+标准化AI开放能力和80+AI行业解决方案，包括为国家人口普查、健康码等提供核心自研AI技术能力等。</p>
                <p>公有云日处理图像超50亿张，日处理语音超250万小时，日处理自然语言超千亿句。</p>
                <p>在新加坡、马来西亚、印度、泰国、韩国、菲律宾等亚太国家提供直接的产品服务和技术支持，服务全球用户数超过12亿。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BackOpenChenter from '@/components/open/panels/news/detail/BackOpenChenter';
export default {
  name: 'News14',
  components: {
    BackOpenChenter
  }
};
</script>

<style lang="less" scoped>
@import "./news.less";
.news-content {
  width: 820px;
  margin: 0 auto;
  h3 {
    text-align: center;
    color: #0152d9;
  }
}
.news-content-text-nlp {
  padding-left: 20px;
}
.news-content-box {
  margin-top: 25px;
  &-top {
    width: 65%;
    height: 34px;
    border: 1px #595959 solid;
    border-bottom: none;
    padding: 5px 5px 5px 15px;
    line-height: 34px;
    span {
      &:nth-child(1) {
        color: #0167ff;
      }
      &:nth-child(2) {
        color: #909090;
      }
    }
  }
  &-bottom {
    display: flex;
    .left {
      border-top: 1px #595959 solid;
      width: 13px;
      box-shadow: #fff -3px 3px 0px inset;
      background-color: #0152d9;
      height: auto;
      align-self: stretch;
      visibility: visible;
      overflow-wrap: break-word !important;
    }
    .right {
      flex: 30;
      width: 65%;
      min-height: 186px;
      border: 1px #595959 solid;
      border-top: none;
      padding: 0px 20px 10px 10px;
      .right-description {
        border-top: 1px #595959 solid;
        div {
          max-width: 85px;
          width: 70px;
          height: 23px;
          font-size: 16px;
          font-weight: 600;
          color: #fff;
          background-color: #0152d9;
          margin-top: 25px;
          margin-bottom: 25px;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/open/panels/news/detail/News14.vue